<template>
    <v-toolbar dense flat color="blue noborderradius" dark> 
        <v-flex hidden-sm-and-down>
        <div class="title">{{getDocTitle()}}</div>         
        </v-flex>
        <v-flex v-if="($store.state.usuario.type == 'Comercial') && ($store.state.customer.no != '')"  class="orderData">
            {{$store.state.customer.no}} - 
            {{$store.state.customer.name}}
        </v-flex>
        <v-flex v-else class="orderData">
            {{$store.state.usuario.custNo}} - 
            {{$store.state.usuario.custName}}
        </v-flex>
        <v-spacer></v-spacer>            
        
    </v-toolbar>  
</template>
<script>
import { setTimeout } from 'timers';
export default {
    name: 'toolbarListaCatalogo',
    data(){
        return{
            searchTimeout: null
        }
    },
    methods:{        
        
    },
    computed:{
        filter: {
            get(){
                return this.$store.state.filter;
            },
            set(value){
                this.$store.commit('setItemsFilter', value);
            }
        },
        menuitems:{
            get(){
                return this.$store.state.menuitems;
            }
        }
    }
}
</script>
<style scoped>
.title{
    font-size: 14px!important
    }
</style>